export default __webpack_public_path__ + "static/media/pitbull.204c2ac3.png";